
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/slownik-pojec",
      function () {
        return require("private-next-pages/docs/slownik-pojec.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/slownik-pojec"])
      });
    }
  